<template>
  <div class="list-card-row flex align-center">
    <router-link :to="{ name: cardLink.name, params: cardLink.params }"
        class="flex align-center row-link">
      <div v-for="cell in cells" :key="cell.id" :class="cell.classes" class="cell">
        <span v-if="cell.isHtml" v-html="cell.value"></span>
        <span v-else>{{ cell.value }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ListRow',
  props: {
    model: Object,
  },

  data() {
    return {
      style: {
        height: 0,
      },
      expanded: false,
    }
  },

  computed: {
    cells() {
      return this.model.cells || []
    },

    cardLink() {
      return this.model.link || {}
    },
  },

  methods: {
  },

  created() {},

  mounted() {},
}
</script>

<style lang="scss">
.list-card-row {
  width: 100%;
  margin: 0;
  border-radius: $border-radius;
  border: 1px solid color(surface-container-lowest);
  background-color: color(surface-container);

  &:hover {
    background-color: color(surface-container-highest);
    cursor: pointer;
  }

  .row-link {
    color: color(on-surface);
    text-decoration: none;
    padding: $padding;
    display: flex;
    flex: 1;
  }

  .cell {
    padding: 0 $padding;

    &.right {
      text-align: right;
      padding: 0 $padding;
    }
  }

  .cell-small {
    width: 100px;
  }

  .cell-medium {
    width: 150px;
  }

  .cell-large {
    width: 200px;
  }

  .cell-xlarge {
    width: 225px;
  }
}
</style>
